import TextEditor, { TextEditorProps } from '@repo/ui/text-editor'

import { useFormField } from '../forms/form'

const ControlledTextEditor: React.FC<TextEditorProps> = (props) => {
  const { error } = useFormField()

  return <TextEditor {...props} errorMessage={error ? String(error?.message) : undefined} />
}

export default ControlledTextEditor
